import Tone from 'tone';
import Notes from 'midi/Notes.js';
import Voice from './Voice.js';

export default superclass => class extends superclass  {
    voiceCounter = 0;
    voiceToTranspose = {};
    frequencyToVoice = {};
    voiceToFrequency = {};
    voicesUsed = [];
    numberToVoice = {};

    useVoice(note, time) {
        let v = this.findFreeVoice(time, note);
        return this.buildVoice(v);
    }

    buildVoice(voiceNumber) {
        return new Voice(
            this.carrierOscillator.voices[voiceNumber],
            this.modulatorOscillators.map(
                osc => osc.voices[voiceNumber]),
            voiceNumber);
    }

    /**
     * When the synth wants to play a new note, it uses this function
     * to determine which of the n-voices (where n=polyphony limit) is
     * to be used. this is important, b/c stealing a voice that is
     * already being used at the moment, can cause problems
     */
    findFreeVoice(time=Tone.Master.context.currentTime, note) {
        // first see if there is a voice with that frequency already playing
        let freq = this.oscillators[0].getNoteFromTranspose(note).toFrequency();
        for (let voice in this.voiceToFrequency) {
            if (parseInt(voice) >= this.polyphonyParameter.get()) {
                continue;
            }
            let voiceFreq = this.voiceToFrequency[voice];
            if (voiceFreq === freq) {
                // there is a voice that last played this frequency,
                // so we use it! easy peasy!
                return parseInt(voice);
            }
        }

        // otherwise let's then find a voice that has an envelope of 0
        // meaning it isn't being used
        let voices = this.oscillators[0].voices;
        let _c = this.voiceCounter;
        for (let i=0; i < this.polyphonyParameter.get(); i++) {
            let num = (_c + i) % voices.length;
            let envValue = voices[num].envelope.getValueAtTime(time);
            if (envValue === 0) {
                return parseInt(num);
            }
        }

        // otherwise we find the voice we haven't used in the longest time
        let _voices = [];
        for (let i=this.voicesUsed.length -1; i >= 0; i--) {
            _voices = Array.from(new Set([... _voices, this.voicesUsed[i]]));
            if (_voices.length === this.polyphonyParameter.get()) {
                return this.voicesUsed[i];
            }
        }
        return this.polyphonyParameter.get() - 1;
    }

    // Keeps track of what voice is using which frequency
    storeVoiceFrequency(note, voiceCounter, voice) {
        let freq = this.oscillators[0].getNoteFromTranspose(note);
        this.frequencyToVoice[freq.toFrequency()] = voiceCounter;
        this.voiceToFrequency[voiceCounter] = freq.toFrequency();
        this.voiceCounter = (this.voiceCounter + 1) % this.polyphonyParameter.get();
        this.numberToVoice[voiceCounter] = voice;
    }

    clearVoiceData(releaseAll=true) {
        if (releaseAll) {
            this.releaseAll();
        }
        this.voiceCounter = 0;
        this.voiceToTranspose = {};
        this.frequencyToVoice = {};
        this.voiceToFrequency = {};
        this.voicesUsed = [];
        this.numberToVoice = {};
    }
}
